import * as React from 'react';
var TriggerContext = /*#__PURE__*/React.createContext(null);
export default TriggerContext;